import { Button, Text } from '@ksyos/design-system';
import { useState } from 'react';
import { ToastType } from '@common/enums';
import { Modal } from '@frontend/components/elements/modals/Modal';
import { getSelectedLanguage } from '@frontend/translate';
import { useProcessActivityContext, useProcessActivityEditContext } from '@frontend/utils';
import { showToast } from '@frontend/utils/showToast';
import { getModalText, getToastText } from './processActivityEditUtil';

type ProcessActivityEditCancelButtonProps = Readonly<{
    isDisabled?: boolean;
}>;

export function ProcessActivityEditCancelButton(props: ProcessActivityEditCancelButtonProps) {
    const { isDisabled } = props;
    const {
        serviceActivity: { serviceActivityType },
        processActivity,
    } = useProcessActivityContext();
    const { handleCancel } = useProcessActivityEditContext();
    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <Button
                isDisabled={isDisabled}
                onClick={() => setShowModal(true)}
                type="button"
                variant="outline"
            >
                {getSelectedLanguage().common.cancel}
            </Button>

            {showModal && (
                <Modal
                    actionButtons={[
                        <Button
                            key="no"
                            onClick={() => setShowModal(false)}
                            variant="outline"
                        >
                            {getSelectedLanguage().common.no}
                        </Button>,
                        <Button
                            key="yes"
                            onClick={async () => await onYesCancel()}
                        >
                            {getSelectedLanguage().common.yes}
                        </Button>,
                    ]}
                    isOpen={true}
                    onClose={() => setShowModal(false)}
                    size="small"
                    title={getSelectedLanguage().common.cancelForm}
                >
                    <Text>{getModalText(processActivity, serviceActivityType)}</Text>
                </Modal>
            )}
        </>
    );

    async function onYesCancel(): Promise<void> {
        setShowModal(false);
        await handleCancel();
        showToast(ToastType.info, getToastText(processActivity, serviceActivityType));
    }
}
